<template>
  <div class="pageWrap">
      <div class="right">
        <div class="searchContent">
          <div class="oildataPicker1">
            <span class="name">日期</span>
            <el-date-picker
                v-model="value1"
                type="datetimerange"
                unlink-panels
                style="margin-left: 10px; margin-right: 10px"
                start-placeholder="选择开始日期"
                end-placeholder="选择结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions">
            </el-date-picker>
          </div>
          <span class="searchInputText">工况</span>
          <el-input placeholder="请选择需要查询的工况" v-model="maintaiSearch" @focus="selectModBoxVisible=true"></el-input>
          <i class="el-icon-caret-bottom iconbottom"></i>
          <el-button  type="danger" @click="doSearch">查找</el-button>
          <el-button v-show="downloadExcelShow" class="download" type="warning" plain @click="downloadExcel" icon="el-icon-download">下载</el-button>
          <el-button v-show="!downloadExcelShow" class="download" type="warning" :loading="true" plain>下载..</el-button>
        </div>
        <div class="listContain4">
          <div class="tablelistBody">
            <el-table
              :data="dataList"
              style="width: 100%"
              size="medium"
              height= '575px'
              v-loading="listLoading"
            >
              <el-table-column prop="order" label="序号" width="60">
                <template slot-scope="scope">
                    <span >{{scope.$index+1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="create_date" label="时间" width="200"></el-table-column>
              <el-table-column :prop="item.prop" :label="item.label" v-for="(item,index) in canzhaoList" :key="index" width=""></el-table-column>
            </el-table>
          </div>
           <div class="pageblock">
            <el-pageCover
              class="pageBlock"
              :pageMsg="pageMsg"
              :page-sizes="[5, 10]"
              :layout="layout"
              @sizeChange="pageSizeChange"
              @currentChange="currentPageChange"
            ></el-pageCover>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="selectModBoxVisible" custom-class='selectStatus' @close="closeDialogFun" width="25%" top="40vh">
        <div class="statusCon">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 10px 0;height:1px;background:#c8c8c8;width:150px"></div>
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in cities" :label="city.name" :key="city.id">{{city.cnName+'('+city.unit+')'}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-dialog>
    </div>
</template>
<script>
import { Message } from "element-ui";
import ElPageCover from "../../../components/overall/ElPageCover";
import { toChineseDate } from "../../../utils/commons";
import { getWorkStatusNames,getWorkStatus,exportWorkStatus } from "../../../utils/api";
export default {
  data() {
    return {
      multipleSelection: [],
      actionName: "",
      modelObj: {},
      maintaiSearch:'',
      selectModBoxVisible: false,
      chartOption: {},
      listLoading:false,
      layout: " prev, pager, next, sizes, jumper , total",
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      dataList: [],
      canzhaoList:[],
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      value1:null,
      pickerOptions: {
          shortcuts: [{
          text: '最近一周',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
          }
          }, {
          text: '最近一个月',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
          }
          }, {
          text: '最近三个月',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
          }
          }],
          disabledDate: (time) => {
          return time.getTime() > Date.now();
          }
      },
      downloadExcelShow: true,
    };
  },
  props: ["code","workIndex"],
  watch:{
    code(){
      this.reset()
    }
  },
  computed: {
    rules: function () {
      return {
        careCont: [{ required: true, message: "必填" }],
        careTime: [{ required: true, message: "必填" }],
        principal: [{ required: true, message: "必填" }],
        principalPhone: [{ required: true, message: "必填" }],
      };
    },
  },
  created() {},
  mounted() {
    getWorkStatusNames({equipCode:this.code}).then(res=>{
      if(res.data.code==200){
        this.cities=res.data.content.dataList
        this.cities.map(item=>{
          this.canzhaoList.push({
            prop:item.name,
            label:item.cnName+'('+item.unit+')'
          })
        })
      }
    })
  },
  components: { ElPageCover },
  methods: {
    //关闭弹窗后
    closeDialogFun(){
      this.maintaiSearch=''
      this.cities.map(item=>{
        this.checkedCities.map(j=>{
          if(j==item.name){
            this.maintaiSearch+=item.cnName+'('+item.unit+')'+','
          }
        })
      })
      this.maintaiSearch=this.maintaiSearch.substr(0, this.maintaiSearch.length - 1);
    },
    //dialog多选
    handleCheckAllChange(val) {
      if(val){
        this.checkedCities=this.cities.map(item=>{
          return item.name
        })
      }else{
        this.checkedCities =  []
      }
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      console.log(value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    //分页
    pageSizeChange(size){
      this.pageMsg.pageSize=size;
      this.doSearch();
    },
    currentPageChange(index){
      this.pageMsg.pageNo=index;
      this.doSearch();
    },
    //下载
    async downloadExcel(){
      if(this.value1==null){
          this.$message({
              message: '请选择下载时间段！',
              type: 'warning'
          });
          return
      }
      if(this.checkedCities.length==0){
        Message.warning('请选择要下载的工况!')
        return
      }
      this.loading=true;
      this.downloadExcelShow = false
      let InstructionManualvv='';
      let fileName='';
          InstructionManualvv = await exportWorkStatus({equipCode:this.code,columnNames:this.checkedCities.join(','),startTime:this.value1[0],endTime:this.value1[1]});
          fileName = this.code+'工况列表'+this.value1[0]+'.xls';
      let blob = new Blob([InstructionManualvv.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});  
      if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
      } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href) //释放内存
      }
      this.loading=false
      this.downloadExcelShow = true
  },
  reset(){
    this.value1=null
    this.multipleSelection=[]
    this.maintaiSearch=''
    this.dataList=[]
    this.pageMsg= {
      pageSize: 10,
      pageNo: 1,
      totalRecords: 0,
    }
  },
    doSearch(){
      if(this.checkedCities.length==0){
        Message.warning('请选择要查询的工况!')
        return
      }
      if(this.value1==null){
        Message.warning('请选择查询时间段!')
        return
      }
      this.listLoading=true;
      getWorkStatus({
        equipCode:this.code,
        columnNames:this.checkedCities.join(','),
        startTime:this.value1[0],
        endTime:this.value1[1],
        pageNo:this.pageMsg.pageNo,
        pageSize:this.pageMsg.pageSize
        }).then(res=>{
          if(res.data.code==200){
            let list=res.data.content.page.list
            this.pageMsg.totalRecords=res.data.content.page.totalRecords
            list.map(item=>{
              this.checkedCities.map(j=>{
                if(item[j]==undefined){
                  item[j]='-'
                }
              })
              item.create_date=toChineseDate(item.create_date)
            })
            this.dataList=list
            this.canzhaoList=[]
            this.cities.map(item=>{
              this.checkedCities.map(j=>{
                if(item.name==j){
                  this.canzhaoList.push({
                    prop:item.name,
                    label:item.cnName+'('+item.unit+')'
                  })
                }
              })
            })
          }
          this.listLoading=false
      });
    }
  }
  
}
</script>
<style lang="scss">
  .selectStatus {
    width: 450px !important;
    .el-dialog__body{
      padding-top: 0px !important;
      .statusCon{
        .el-checkbox-group{
          .el-checkbox{
            .el-checkbox__label{
              width: 90px !important;
              padding-top: 10px !important;
            }
          }
        }
      }
    }
  }
  .takecare {
    .el-input {
      width: 220px !important;
    }
}
.listContain4 {
      .tablelistBody{
        .el-table{
          height: 575px !important;
          .el-table__body-wrapper{
            height: 531px !important;
          }
        }
        // overflow: auto;
      }
  }
</style>
<style lang="scss" scoped="">
.pageWrap {
  width: 100%;
  height: 658px;
    .right {
      width: 100%;
      height: 568px;
      padding-top: 20px;
      .searchContent {
        position: relative;
        height: 65px;
        width: 80%;
        padding: 10px 17px;
        display: flex;
        align-items: center;
        .oildataPicker1{
            .name{
            font-size: 14px;
            }
        }
        .iconbottom{
          color:#c8c8c8;
          position:absolute;
          top:23px;
          left:670px
        }
      }
      .listContain4 {
        width: 98.5%;
        margin: 0 auto;
        position: relative;
        .tablelistBody {
          margin-left: 6px;
          height: 575px;
        }
        .pageblock {
          position: absolute;
          top: 560px;
          right: 20px;
        }
      }
    }
}
</style>
<style lang='scss'>
  .oildataPicker1{
    .el-date-editor{
    height: 32px !important;
    width: 360px !important;
    border-radius: 0 !important;
    .el-input__icon{
      line-height: 24px !important;
    }
    .el-range-separator{
      line-height: 24px !important;
    }
  }
  }
</style>